module.exports = __webpack_public_path__ + "img/back-arrow.76f6da3c.svg";